// =============================================
// COMPONENTE: SCHEDULE NODE
// =============================================
// Arquivo: ScheduleNode.tsx
// Descrição: Nó para gerenciamento de agendamentos
// =============================================

import React from 'react';
import { Handle, Position, NodeProps } from 'reactflow';
import { Calendar } from 'lucide-react';
import ActionsBadge from './ActionsBadge';

const ScheduleNode: React.FC<NodeProps> = ({ data, selected }) => {
  const { label, operation, datetime, description, actions } = data;

  const getOperationLabel = (op: string) => {
    const labels: Record<string, string> = {
      create: 'Criar',
      update: 'Atualizar',
      cancel: 'Cancelar',
      list: 'Listar'
    };
    return labels[op] || op;
  };

  return (
    <div className={`flow-node schedule-node ${selected ? 'selected' : ''}`}>
      <Handle type="target" position={Position.Top} className="flow-handle" />

      <div className="node-header schedule-header">
        <Calendar className="node-icon" size={18} />
        <span className="node-title">{label || 'Agendamento'}</span>
      </div>

      <div className="node-body">
        {operation && (
          <div className="node-field">
            <span className="field-label">Operação:</span>
            <span className="field-value">{getOperationLabel(operation)}</span>
          </div>
        )}
        {datetime && (
          <div className="node-field">
            <span className="field-label">Data/Hora:</span>
            <span className="field-value code">{datetime}</span>
          </div>
        )}
        {description && (
          <div className="node-description">{description}</div>
        )}
        <ActionsBadge actions={actions} />
      </div>

      <Handle type="source" position={Position.Bottom} className="flow-handle" />
    </div>
  );
};

export default ScheduleNode;
